import validateEmail from './validate-email';
import validatePassword from './validate-password';

const validateForm = (formData = {}) => {
  let isValid = true;

  const validatedFormData = { ...formData };
  Object.keys(formData).forEach(key => {
    const { value: currentValue, isRequired } = formData[key];

    if (!currentValue && isRequired) {
      isValid = false;
      validatedFormData[key].error = true;
    } else if (key === 'email' && !validateEmail(currentValue)) {
      isValid = false;
      validatedFormData[key].error = true;
    } else if (key === 'password' && !validatePassword(currentValue)) {
      isValid = false;
      validatedFormData[key].error = true;
    } else if (key === 'passwordConfirm' && formData.password.value !== currentValue) {
      isValid = false;
      validatedFormData[key].error = true;
    } else {
      validatedFormData[key].error = false;
    }
  });

  return [isValid, validatedFormData];
};

export default validateForm;
